///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rx_item_hda_form = abcsetup.rx_item_hda_form || {};



///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.rx_item_hda_form.index = {
    init: function() {
        abcsetup.setTitle('Rx HDA Forms');

        // Delete button clicked
        $(document).on('click', '#rxitemhdaform-table .btn-delete', function () {
            var _this = $(this);

            abcsetup.alerts.confirm('Delete Item', 'Are you sure you want to delete this record?', function (resp) {
                if (resp) {
                    abcsetup.rx_item_hda_form.index.delete(_this.data('id'));
                }
            });
        });

        let errors = false;
        function poll_import_item() {
           $("#rxitemhdaform-table > tbody > tr div.status").each(function() {
                var status_element = $(this);
                var id = status_element.data("id");
                var status = status_element.data("status");
                var row = status_element.closest('tr');

                if (!id || !status) {
                    console.log('poll_import_item: invalid id/status');
                    return;
                }

                if (status != 3 && status != 4) {
                    console.log("Polling");
                    axios.get("/api/rx_item_hda_form/record/"+id)
                        .then(result => {
                            console.log(JSON.stringify(result,{},4));
                            if (result.data.status == 3) {
                                status_element.toggleClass("alert-info alert-danger");
                            } else if (result.data.status == 4) {
                                status_element.toggleClass("alert-info alert-success");

                                if (result.data.entity_type == "rx_item" && result.data.entity_id) {
                                    row.find('td').eq(1).html(
                                        '<a href="/rx_item/'+result.data.entity_id+'/edit" class="btn btn-sm btn-primary mr-1" title="Click to edit item">Edit</a>'
                                    );

                                    row.find('td').eq(2).html(result.data.entity_name);
                                    row.find('td').eq(3).html(result.data.vendor_name);
                                    row.find('td').eq(6).html(result.data.hda_version);
                                    row.find('td').eq(7).html(result.data.page_count);
                                }
                            }
                            status_element.data("status",result.data.status);

                            if (result.data.status == 3 || result.data.status == 4) {
                                status_element.html(result.data.status_text);
                            } else {
                                status_element.find(".status_text").html(result.data.status_text);
                            }
                        })
                        .catch(error => {
                            errors = true;
                            console.log("Error => could not find RxItemHdaForm for id: " + id);
                        });
                }
            });
        }
        setInterval(() => {
            if (! errors) {
                poll_import_item();
            }
        }, 2000);
    },

    delete: function(id) {
        axios.delete('/rx_item_hda_form/' + id).then(response => {
            window.location.reload();
        });
    },
};
